import { render, staticRenderFns } from "./UpdateThankfulTime.vue?vue&type=template&id=d945d9d4&scoped=true"
import script from "./UpdateThankfulTime.vue?vue&type=script&lang=js"
export * from "./UpdateThankfulTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d945d9d4",
  null
  
)

export default component.exports